export class AutoLockRequestDecisionModel {
  TransactionId: string;
  FeatureType: string;
  IpAddress: string;
  RecipientKey: string;
}
//   export class AutoLockDecisionResultContent {
//     RequestsCount: number;
//     RequestStatus: number;
//   }

export class AutoLockDecisionResponse {
  status: string;
  statusCode: number;
  statusText: string;
  success: boolean;
  message: AutoLockDecisionMessage;
  resultContent: AutoLockDecisionResultContent;
}

export class AutoLockDecisionMessage {
  message: string;
  messageCode: string;
}

export class AutoLockDecisionResultContent {
  requestsCount: number | null;
  requestStatus: number | null;
}
export class AccessDecision {
  Id: string | null = null;
  Feature: string | null = null;
  Key: string | null = null;
  Count: number | null = null;
  Status: number | null = null;
  Lang: string | null = null;
  RefUrl: string | null = null;
  Theme: string | null = null;
  Source: string | null = null;
  hashedLockId: string | null = null;
  EMailDispatchOption: number | null = null;
  PhoneNumber: string | null = null;
  DestinationName: string | null = null;
  SenderAddress: string | null = null;
  MessageSubject: string | null = null;
  DestinationAddress: string | null = null;

}
